import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { WebApiPagedCollectionResult, mapCollection } from '@mango/core';
import { Merk } from 'src/app/core/dto/merk';
import { Soort } from 'src/app/core/dto/soort';
import { map } from 'rxjs/operators';

@Injectable()
export class PrijscorrectieService {

    constructor(private http: HttpClient) {
 
    }

  Prijscorrectie(alles: boolean, soortID: Soort, merkID: Merk, prijsStd: number, prijsCY: number, prijsRvA: number, prijsNen: number, prijsKeuring: number, prijsBrl100: number, prijsCrossCheck: number, prijsScios: number, prijsBRL6010: number, prijsPool: number, prijsKwestie: number, prijsPoolBuiten: number, prijsKwestieBuiten: number) {

        var soort = -1;
        var merk = -1;

        if (soortID != null) {
            soort = soortID.id;
        }
        
        if (merkID != null) {
            merk = merkID.id;
        }

    let query: string = `api/dto/instrumentdefinitie/prijscorrectie?alles=${alles}&soortID=${soort}&merkID=${merk}&prijsStd=${prijsStd}&prijsCY=${prijsCY}&prijsRvA=${prijsRvA}&prijsNen=${prijsNen}&prijsKeuring=${prijsKeuring}&prijsBrl100=${prijsBrl100}&prijsCrossCheck=${prijsCrossCheck}&prijsScios=${prijsScios}&prijsBRL6010=${prijsBRL6010}&prijsPool=${prijsPool}&prijsKwestie=${prijsKwestie}&prijsPoolBuiten=${prijsPoolBuiten}&prijsKwestieBuiten=${prijsKwestieBuiten}`
        
        return this.http.post(query, null).pipe(map(x => x as PrijscorrectieResponse));
    }
    
}

export class PrijscorrectieResponse {
    successful: boolean;
    message: string;
}
